module.exports = __webpack_public_path__ + "static/img/bookmark_hover.9321314f.svg";